import { GSD_DATASOURCE_METRICS } from '@intelligence/_config/sourceMetric';

export const FILE_FORMATS = [
  { label: 'Excel', value: '0' },
  { label: 'CSV', value: '1' },
];

export const EXPORT_ALL_DATA_AMOUNTS = [{ label: 'dbi_export_all_data', value: 'selectAll' }];

export const DATA_AMOUNTS = [
  ...EXPORT_ALL_DATA_AMOUNTS,
  { label: 'dbi_select_top', value: 'selectTop' },
];

export const DATA_AMOUNTS_CHECKED = [
  ...DATA_AMOUNTS,
  { label: 'dbi_export_checked_lines', value: 'checkedLines' },
];

export const DATA_AMOUNTS_ALL_AND_CHECKED= [
  ...EXPORT_ALL_DATA_AMOUNTS,
  { label: 'dbi_export_checked_lines', value: 'checkedLines' },
];

export const SELECT_TOP = 6;

export const DOWNLOAD_TITLE_TIPS = 'dbi_download_tips';

// 注意这里文本的修改，需要同步修改src/pages/intelligence/components/DownloadCommon/DownloadPage/configs/mobileDetail.ts中的defaultSelectCondition，那边会根据哪些页面默认勾选哪些指标
export const segmentDataSettingList = [
  {
    label: 'activeusers',
    value: ['au'],
  },
  {
    label: 'revenue',
    value: ['rv', 'arpu'],
  },
  {
    label: 'downloads',
    value: ['dl'],
  },
  {
    label: 'retention—retention_monthly',
    value: ['mr', 'lr'],
  },
  {
    label: 'retention—retention_monthly_sensortower',
    value: ['mr', 'lr'],
  },
  {
    label: 'retention—retention_lifetime',
    value: ['mr', 'lr'],
  },
  {
    label: 'rpd',
    value: ['rp', 'cr', 'cd'],
  },
];

export const getStatsMetric = (segment: string): string[] => {
  const targetDataSetting = segmentDataSettingList?.find((item) => item.label === segment);
  return targetDataSetting ? targetDataSetting?.value : ['au'];
};

export const ORDER_METRICS_AMPERE = [
  {
    dataSource: 'ampere',
    metric: 'ampere_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_previous_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_added_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_new_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_retained_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_churned_mau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_dau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_new_dau',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_avg_monthly_playtime',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_acquisition_rate',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_stickiness',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_lifetime_users',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_avg_dailly_playtime',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_d1',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_d7',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_d14',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_d28',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_d60',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_rolling_d1',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_rolling_d7',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_rolling_d14',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_rolling_d28',
  },
  {
    dataSource: 'ampere',
    metric: 'ampere_rolling_d60',
  },
];

export const ORDER_METRICS_PC = [
  {
    dataSource: 'source_steam',
    metric: 'source_steam__pcu',
  },
  {
    dataSource: 'source_steam',
    metric: 'source_steam__acu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'pcu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamfollowers',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__pcu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__acu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__weighted_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__playtime',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__players_by_country',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__pcu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__acu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamfollowers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamreviews',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__weighted_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__followers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__players_by_country',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__playtime',
  },

  {
    dataSource: 'vginsights',
    metric: 'est_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_price',
  },
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },

  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },

  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
];

export const ORDER_METRICS_PC_DETAIL = [
  {
    dataSource: 'source_steam',
    metric: 'source_steam__pcu',
  },
  {
    dataSource: 'source_steam',
    metric: 'source_steam__acu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'pcu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamfollowers',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__pcu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__acu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__weighted_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__lifetime_weighted_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__players_by_country',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__playtime',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__pcu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__acu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamfollowers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamreviews',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__weighted_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__followers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__players_by_country',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__playtime',
  },
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },

  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },

  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
  // 转换新接口后，新加参数
  {
    dataSource: 'stream',
    metric: 'hoursWatched',
  },
  {
    dataSource: 'stream',
    metric: 'peackCCV',
  },
  {
    dataSource: 'stream',
    metric: 'avgCCV',
  },
  {
    dataSource: 'stream',
    metric: 'airtime',
  },

  {
    dataSource: 'vginsights',
    metric: 'est_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'weighted_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'lifetime_weighted_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'players_by_country',
  },
  {
    dataSource: 'vginsights',
    metric: 'playtime',
  },
  {
    dataSource: 'vginsights',
    metric: 'followers',
  },
];

export const ORDER_METRICS_CONSOLE_DETAIL = [
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },
  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   dataSource: 'famitsu',
  //   metric: 'week_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'usd_price',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'revenue',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_revenue',
  // },
  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
  // 转换新接口后，新加参数
  {
    dataSource: 'stream',
    metric: 'hoursWatched',
  },
  {
    dataSource: 'stream',
    metric: 'peackCCV',
  },
  {
    dataSource: 'stream',
    metric: 'avgCCV',
  },
  {
    dataSource: 'stream',
    metric: 'airtime',
  },
];

export const ORDER_METRICS_CONSOLE = [
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },

  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },

  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
];

export const ORDER_METRICS_COMBINE = [
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },
  {
    dataSource: 'source_steam',
    metric: 'source_steam__pcu',
  },
  {
    dataSource: 'source_steam',
    metric: 'source_steam__acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__pcu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__acu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__wishlists',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__wishlists_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__mau',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_cumulative_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_cumulative_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__pcu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__acu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamfollowers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__wishlists',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__wishlists_total',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamreviews',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_units',
  },
  {
    dataSource: 'steamcharts',
    metric: 'pcu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'wishlists',
  },
  {
    dataSource: 'vginsights',
    metric: 'wishlists_total',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_game_pass_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_game_pass_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_mau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_game_pass_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_game_pass_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_mau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_price',
  },
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   dataSource: 'famitsu',
  //   metric: 'famitsu_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'famitsu_price',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'famitsu_revenue',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'famitsu_cumulative_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'famitsu_cumulative_revenue',
  // },
  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
  {
    dataSource: 'metacritic',
    metric: 'meta_score',
  },
  ...ORDER_METRICS_AMPERE,
];

export const ORDER_METRICS_COMBINE_DETAIL = [
  {
    dataSource: 'source_steam',
    metric: 'source_steam__pcu',
  },
  {
    dataSource: 'source_steam',
    metric: 'source_steam__acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__pcu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__acu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__wishlists',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__wishlists_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__lifetime_weighted_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__playtime',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__mau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_game_pass_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_game_pass_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_mau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__ps_price',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_cumulative_revenue',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_est_cumulative_units',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_game_pass_players',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_game_pass_players_total',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_dau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_mau',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__xbox_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_cumulative_revenue',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_cumulative_units',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__pcu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__acu',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamfollowers',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__wishlists',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__wishlists_total',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__est_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__lifetime_weighted_price',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__playtime',
  },
  {
    dataSource: 'gamalytic',
    metric: 'gamalytic__steamreviews',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_units',
  },
  {
    dataSource: 'steamcharts',
    metric: 'pcu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'acu',
  },
  {
    dataSource: 'vginsights',
    metric: 'wishlists',
  },
  {
    dataSource: 'vginsights',
    metric: 'wishlists_total',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'lifetime_weighted_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'playtime',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamreviews',
  },
  ...GSD_DATASOURCE_METRICS,
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },

  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'npd',
    metric: 'physical_units',
  },
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   dataSource: 'famitsu',
  //   metric: 'week_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'usd_price',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'revenue',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_revenue',
  // },
  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },

  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
  // 转换新接口后，新加参数
  {
    dataSource: 'stream',
    metric: 'hoursWatched',
  },
  {
    dataSource: 'stream',
    metric: 'peackCCV',
  },
  {
    dataSource: 'stream',
    metric: 'avgCCV',
  },
  {
    dataSource: 'stream',
    metric: 'airtime',
  },
  ...ORDER_METRICS_AMPERE,
];

export const OrderMetricsMap = {
  pcPCU: [
    {
      dataSource: 'alinea',
      metric: 'alinea__pcu',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__acu',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__steamfollowers',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__steamreviews',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__pcu',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__acu',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__steamfollowers',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__steamreviews',
    },
    // source_steam 指标
    {
      dataSource: 'source_steam',
      metric: 'source_steam__pcu',
    },
    {
      dataSource: 'source_steam',
      metric: 'source_steam__acu',
    },
    // VGI 指标
    {
      dataSource: 'steamcharts',
      metric: 'pcu',
    },
    {
      dataSource: 'steamcharts',
      metric: 'acu',
    },
    {
      dataSource: 'vginsights',
      metric: 'steamfollowers',
    },
    {
      dataSource: 'vginsights',
      metric: 'steamreviews',
    },
  ],
  consolePCU: [
    {
      dataSource: 'steamcharts',
      metric: 'pcu',
    },
    {
      dataSource: 'steamcharts',
      metric: 'acu',
    },
  ],
  pcDigitalRevenue: [
    {
      dataSource: 'mscience',
      metric: 'digitalRevenue',
    },
    {
      dataSource: 'mscience',
      metric: 'units',
    },
    {
      dataSource: 'mscience',
      metric: 'digitalARPPU',
    },
    {
      dataSource: 'mscience',
      metric: 'ast',
    },
  ],
  consoleDigitalRevenue: [
    {
      dataSource: 'mscience',
      metric: 'digitalRevenue',
    },
    {
      dataSource: 'mscience',
      metric: 'units',
    },
    {
      dataSource: 'mscience',
      metric: 'digitalARPPU',
    },
    {
      dataSource: 'mscience',
      metric: 'ast',
    },
  ],
  pcPhysicalRevenue: [
    {
      dataSource: 'npd',
      metric: 'revenue',
    },
    {
      dataSource: 'npd',
      metric: 'physical_units',
    },
  ],
  consolePhysicalRevenue: [
    {
      dataSource: 'npd',
      metric: 'revenue',
    },
    {
      dataSource: 'npd',
      metric: 'physical_units',
    },
  ],
  pcMAU: [
    {
      dataSource: 'newzoo',
      metric: 'mau',
    },
    {
      dataSource: 'newzoo_weight',
      metric: 'acquisition',
    },
  ],
  pcSteamSales: [
    {
      dataSource: 'alinea',
      metric: 'alinea__est_revenue',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__est_units',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__est_price',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__weighted_price',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__playtime',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__steamfollowers',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__players_by_country',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__dau',
    },
    {
      dataSource: 'alinea',
      metric: 'alinea__mau',
    },
    // Gamalytic 指标 (7个)
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__est_revenue',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__est_units',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__est_price',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__weighted_price',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__playtime',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__steamfollowers',
    },
    {
      dataSource: 'gamalytic',
      metric: 'gamalytic__players_by_country',
    },
    // VGI 指标 (7个)
    {
      dataSource: 'vginsights',
      metric: 'est_revenue',
    },
    {
      dataSource: 'vginsights',
      metric: 'est_units',
    },
    {
      dataSource: 'vginsights',
      metric: 'est_price',
    },
    {
      dataSource: 'vginsights',
      metric: 'weighted_price',
    },
    {
      dataSource: 'vginsights',
      metric: 'playtime',
    },
    {
      dataSource: 'vginsights',
      metric: 'followers',
    },
    {
      dataSource: 'vginsights',
      metric: 'players_by_country',
    },
  ],
  consoleMAU: [
    {
      dataSource: 'newzoo',
      metric: 'mau',
    },
    {
      dataSource: 'newzoo_weight',
      metric: 'acquisition',
    },
  ],
  pcLifeTimePlayers: [
    {
      dataSource: 'newzoo',
      metric: 'lifetime_player',
    },
  ],
  consoleLifeTimePlayers: [
    {
      dataSource: 'newzoo',
      metric: 'lifetime_player',
    },
  ],
  pcMetricsTable: ORDER_METRICS_PC,
  consoleMetricsTable: ORDER_METRICS_CONSOLE,
  combinePCConsoleMetricsTable: ORDER_METRICS_COMBINE,
} as any;

// newzoo 加权的指标，数据源需要处理为newzoo_weight
export const NEWZOO_WEIGHT_METRICS = [
  'acquisition',
  'avg_daily_playtime',
  'avg_daily_sessions',
  'avg_playtime_per_session',
  'avg_monthly_sessions',
  'churn',
  'time_spent_0H',
  'time_spent_1H',
  'time_spent_5H',
  'time_spent_10H',
  'time_spent_25H',
  'time_spent_50H',
  'retention_d1',
  'retention_d2',
  'retention_d4',
  'retention_d7',
  'retention_d14',
  'retention_d28',
  'avg_days_played',
  'avg_monthly_playtime',
  'stickiness',
  'total_hours',
  'player_share',
];

export const ORDER_METRICS_MAP_DETAIL: any = {
  pc: ORDER_METRICS_PC_DETAIL,
  console: ORDER_METRICS_CONSOLE_DETAIL,
  combine: ORDER_METRICS_COMBINE_DETAIL,
};

export const FOLLOWING_CURRENTGAME_METRICS = [
  {
    dataSource: 'steamcharts',
    metric: 'pcu',
  },
  {
    dataSource: 'steamcharts',
    metric: 'acu',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalRevenue',
  },
  {
    dataSource: 'mscience',
    metric: 'units',
  },
  {
    dataSource: 'mscience',
    metric: 'digitalARPPU',
  },
  {
    dataSource: 'mscience',
    metric: 'ast',
  },
  {
    dataSource: 'npd',
    metric: 'revenue',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'player_share',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_growth',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_new',
  },
  {
    dataSource: 'newzoo',
    metric: 'mau_returning',
  },
  {
    dataSource: 'newzoo',
    metric: 'lifetime_player',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_daily_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_days_played',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_playtime',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_monthly_sessions',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'avg_playtime_per_session',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'stickiness',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'total_hours',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'churn',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'acquisition',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_0H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_1H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_5H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_10H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_25H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'time_spent_50H',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d1',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d2',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d4',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d7',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d14',
  },
  {
    dataSource: 'newzoo_weight',
    metric: 'retention_d28',
  },
  {
    dataSource: 'stream',
    metric: 'hoursWatched',
  },
  {
    dataSource: 'stream',
    metric: 'peackCCV',
  },
  {
    dataSource: 'stream',
    metric: 'avgCCV',
  },
  {
    dataSource: 'stream',
    metric: 'airtime',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamfollowers',
  },
  {
    dataSource: 'vginsights',
    metric: 'steamreviews',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_revenue',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_cumulative_units',
  },
  {
    dataSource: 'vginsights',
    metric: 'est_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'weighted_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'lifetime_weighted_price',
  },
  {
    dataSource: 'vginsights',
    metric: 'players_by_country',
  },
  {
    dataSource: 'vginsights',
    metric: 'playtime',
  },
  {
    dataSource: 'vginsights',
    metric: 'followers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__pcu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__acu',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamfollowers',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__steamreviews',
  },
  {
    dataSource: 'alinea',
    metric: 'alinea__est_revenue',
  },
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   dataSource: 'famitsu',
  //   metric: 'week_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'usd_price',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'revenue',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_sales',
  // },
  // {
  //   dataSource: 'famitsu',
  //   metric: 'total_revenue',
  // },
];
